export default "__VITE_ASSET__CJZCZ0YW__"